import { useEffect, useRef } from "react";

const AD_CLIENT = "ca-pub-7343093367526364";
const AD_SLOT = "8900664322";

/**
 * Reusable Google AdSense slot.
 * Ads only render on the approved production domain (perceptacademy.in).
 * On preview / localhost you'll see the empty box — that's expected.
 */
export default function GoogleAdSlot({
  slot = AD_SLOT,
  format = "auto",
  responsive = true,
  style,
  className = "",
  testId = "google-ad-slot",
}) {
  const insRef = useRef(null);

  useEffect(() => {
    try {
      if (window.adsbygoogle && insRef.current) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (e) {
      /* AdSense unavailable — silent */
    }
  }, []);

  return (
    <ins
      ref={insRef}
      data-testid={testId}
      className={`adsbygoogle ${className}`}
      style={{ display: "block", ...style }}
      data-ad-client={AD_CLIENT}
      data-ad-slot={slot}
      data-ad-format={format}
      data-full-width-responsive={responsive ? "true" : "false"}
    />
  );
}
